class AdpMainNavigationController {
  constructor() {
    this.name = 'adpMainNavigation';
  }
}

export default AdpMainNavigationController;



// WEBPACK FOOTER //
// ./src/app/components/adpMainNavigation/adpMainNavigation.controller.js